module.exports = "<div data-component=\"app-print-receipt\">\n\t<div class=\"footer\">\n\t\t<div class=\"export\">\n\t\t\t<app-simple-export-buttons\n\t\t\t\t[showPrint]=\"true\"\n\t\t\t\t[showNew]=\"false\"\n\t\t\t\t[numberOfButton]=\"2\"\n\t\t\t\t(emitPrint)=\"redirectToReceipt()\">\n\t\t\t</app-simple-export-buttons>\n\t\t</div>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/receipts/print-receipt/print-receipt.component.html
// module id = ../../../../../src/app/master/receipts/print-receipt/print-receipt.component.html
// module chunks = main